import React, { useState } from "react";
import { Grid, Box, Tab, Tabs, Card } from "@mui/material";
import FormBanner from "./Banners/FormBanner";
import TableBanners from "./Banners/TableBanners";
import FormStories from "./Stories/FormStories";
import TableStorie from "./Stories/TableStories";
import FormNotifications from "./Notifications/FormNotifications";
import TableNotifications from "./Notifications/TableNotifications";
import FormAdvSound from "./Sound/FormAdvSound";
import TableAdvSound from "./Sound/TableAdvSound";

const Advertising = () => {
    const [value, setValue] = useState('1');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Card variant="outlined">
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: { xs: 'column', sm: 'row' },
                            direction: 'ltr'
                        }}
                    >
                        <Tabs
                            orientation={window.innerWidth < 600 ? "horizontal" : "vertical"}
                            value={value}
                            onChange={handleChange}
                            aria-label="Vertical tabs example"
                            textColor="secondary"
                            indicatorColor="secondary"

                            sx={{ borderRight: { sm: 1, borderColor: 'divider' } }}
                        >
                            <Tab label="مدیریت اسلایدرها" value="1" />
                            <Tab label="مدیریت استوری ها" value="2" />
                            <Tab label="مدیریت صداها" value="3" />
                            <Tab label="مدیریت اعلان ها" value="4" />
                        </Tabs>
                        <Box sx={{ flexGrow: 1, direction: 'rtl' }}>
                            <TabPanel value={value} index="1">
                                <BannersTabs />
                            </TabPanel>
                            <TabPanel value={value} index="2">
                                <StoriesTabs />
                            </TabPanel>
                            <TabPanel value={value} index="3">
                                <SoundTabs />
                            </TabPanel>
                            <TabPanel value={value} index="4">
                                <NotificationsTabs />
                            </TabPanel>
                        </Box>
                    </Box>
                </Card>
            </Grid>
        </Grid>
    );
};

const TabPanel = ({ children, value, index }) => {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`vertical-tabpanel-${index}`}
            aria-labelledby={`vertical-tab-${index}`}
        >
            {value === index && (
                <Box sx={{ p: 3 }}>
                    {children}
                </Box>
            )}
        </div>
    );
};

const BannersTabs = () => {
    const [nestedValue, setNestedValue] = useState('1');

    const handleNestedChange = (event, newValue) => {
        setNestedValue(newValue);
    };

    return (
        <Box sx={{ width: '100%', direction: 'ltr' }}>
            <Tabs
                value={nestedValue}
                onChange={handleNestedChange}
                aria-label="Nested tabs example"
                textColor="secondary"
                indicatorColor="secondary"
            >
                <Tab label="ثبت اسلایدر جدید" value="1" />
                <Tab label="لیست اسلایدرها" value="2" />
            </Tabs>
            <TabPanel value={nestedValue} index="1">
                <FormBanner />
            </TabPanel>
            <TabPanel value={nestedValue} index="2">
                <TableBanners />
            </TabPanel>

        </Box>
    );
};


const SoundTabs = () => {
    const [nestedValue, setNestedValue] = useState('1');

    const handleNestedChange = (event, newValue) => {
        setNestedValue(newValue);
    };

    return (
        <Box sx={{ width: '100%', direction: 'ltr' }}>
            <Tabs
                value={nestedValue}
                onChange={handleNestedChange}
                aria-label="Nested tabs example"
                textColor="secondary"
                indicatorColor="secondary"
            >
                <Tab label="ثبت صدای جدید " value="1" />
                <Tab label="لیست صداها" value="2" />
            </Tabs>
            <TabPanel value={nestedValue} index="1">
                <FormAdvSound />
            </TabPanel>
            <TabPanel value={nestedValue} index="2">
                <TableAdvSound />
            </TabPanel>
        </Box>
    );
};

const StoriesTabs = () => {
    const [nestedValue, setNestedValue] = useState('1');

    const handleNestedChange = (event, newValue) => {
        setNestedValue(newValue);
    };

    return (
        <Box sx={{ width: '100%', direction: 'ltr' }}>
            <Tabs
                value={nestedValue}
                onChange={handleNestedChange}
                aria-label="Nested tabs example"
                textColor="secondary"
                indicatorColor="secondary"
            >
                <Tab label="ثبت استوری جدید " value="1" />
                <Tab label="لیست استوری ها" value="2" />
            </Tabs>
            <TabPanel value={nestedValue} index="1">
                <FormStories />
            </TabPanel>
            <TabPanel value={nestedValue} index="2">
                <TableStorie />
            </TabPanel>
        </Box>
    );
};
const NotificationsTabs = () => {
    const [nestedValue, setNestedValue] = useState('1');

    const handleNestedChange = (event, newValue) => {
        setNestedValue(newValue);
    };

    return (
        <Box sx={{ width: '100%', direction: 'ltr' }}>
            <Tabs
                value={nestedValue}
                onChange={handleNestedChange}
                aria-label="Nested tabs example"
                textColor="secondary"
                indicatorColor="secondary"
            >
                <Tab label="ثبت اعلان جدید " value="1" />
                <Tab label="اعلان های ارسالی" value="2" />
            </Tabs>
            <TabPanel value={nestedValue} index="1">
                <FormNotifications />
            </TabPanel>
            <TabPanel value={nestedValue} index="2">
                <TableNotifications />
            </TabPanel>
        </Box>
    );
};
export default Advertising;
